import React, {Component} from 'react'
import { Paper, Typography} from '@material-ui/core'
import RadioYesNo from '../controls/RadioYesNo';
import SubmitButton from '../controls/SubmitButton';
import {RadioGroup, FormControlLabel, Radio} from '@material-ui/core';
class Q3 extends Component {
    continue = e => {
       this.props.nextStep(); 
    }

    render() {
        const {values , handleChange } = this.props;
        let showSubmitButton = values.q3 != undefined && values.q3 != '';
        return (
            <Paper elevation={3} className="p-5 mt-3" style={{position:"relative"}}>
            <Typography variant="h6" className="mb-4">
                Is the engagement within the construction industry and subject to HMRC’s CIS scheme?
            </Typography>
            <RadioGroup 
              aria-label=""
              name="rdnoYesNo"
              value={values.q3}
              onChange={this.props.handleChange('q3')}
            
            >
              <FormControlLabel
                value="yes"
                control={<Radio color="primary" />}
                label="Yes"
                labelPlacement="end"
                className="pr-3"
              />
              <FormControlLabel
                value="no"
                control={<Radio color="primary" />}
                label="No"
                labelPlacement="end"
                className=""
              />
              <FormControlLabel
                value="unknown"
                control={<Radio color="primary" />}
                label="I don't know"
                labelPlacement="end"
                className=""
              />
            </RadioGroup>
            <div style={{position:"absolute", 
                
                            bottom:"35px",
                            right:"35px",
                            
                            zIndex:99999}}>
            { showSubmitButton ? (
                <SubmitButton onClick={this.continue}>
                </SubmitButton>
                ) : (<div></div>)}
            </div>

            </Paper>
        );
    }
}
export default (Q3);